export const REDUCER_NAME = 'database';
